export default "__VITE_ASSET__yQ9V8M6I__"